import styles from 'components/ImageMarque/imagemarque.module.scss';

import type { ImageMarqueProps } from 'components/ImageMarque/config';
import type { FC } from 'react';

const ImageMarque: FC<ImageMarqueProps> = ({ image, type }) => {
  const bgImage = image ? { backgroundImage: `url(${image?.url})` } : {};

  return <section className={`${styles.wrapper} ${type === 'full' ? styles.response : ''}`} style={bgImage}></section>;
};

export default ImageMarque;
